import axios from 'axios';
import { BROCHURES_PAGE, GET_ERRORS, CLEAR_BROCHUREDATA } from './types';
import { clearErrors } from './utilities';

const pellaAPIURL = process.env.GATSBY_PELLA_API;

const config = {
	headers: {
		Authorization: 'Bearer ' + process.env.GATSBY_PELLA_BROCHURE_TOKEN,
	},
};

export const postBrochures = (body) => (dispatch) => {
	dispatch(clearErrors());
	axios

		.post(pellaAPIURL + '/brochures/submit', body, config)
		.then((res) =>
			dispatch({
				type: BROCHURES_PAGE,
				payload: res.data,
			})
		)
		.catch((err) => {
			dispatch({
				type: GET_ERRORS,
				payload: err,
			});
		});
};

export const clearBrochures = () => (dispatch) => {
	dispatch(clearErrors());

	dispatch({
		type: CLEAR_BROCHUREDATA,
		payload: '',
	});
};
